import { Box, Button, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { ROW_BTN_SX } from "./gate2Tokens";

export default function Gate2MissingConnectorBanner({ message, onOpenGate1, disabled = false }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: 1.5,
        bgcolor: "#FFFBEB",
        border: "1px solid #FDE68A",
        borderRadius: "8px",
        px: 2,
        py: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25, minWidth: 0 }}>
        <WarningAmberIcon sx={{ color: "#B45309", fontSize: 20, mt: "1px", flexShrink: 0 }} />
        <Typography sx={{ fontFamily: "Lato, sans-serif", fontSize: 13, color: "#B45309" }}>
          {message}
        </Typography>
      </Box>
      <Button
        variant="outlined"
        disableElevation
        disabled={disabled}
        onClick={onOpenGate1}
        sx={{ ...ROW_BTN_SX, flexShrink: 0, whiteSpace: "nowrap" }}
      >
        Open in Gate 1 readiness
      </Button>
    </Box>
  );
}
